import { PATH } from './router'

export const HOST = process.env.REACT_APP_API_URL || 'https://cdn-dev.kiemdinhoto.vn'
export const ZALO_HOST = 'http://zalo.ttdkapi.ttdk.com.vn'
export const IMAGE_HOST = HOST + 'upload/'

const DEVELOP_URL = {
  REACT_APP_URL_WEB_DATLICH: 'https://ttdk-develop-partner.service.makefamousapp.com',
  REACT_APP_URL_WEB_TTDK: 'https://ttdk-develop-web.service.makefamousapp.com'
}

const PRODUCTION_URL = {
  REACT_APP_URL_WEB_DATLICH: 'https://partner.ttdk.com.vn',
  REACT_APP_URL_WEB_TTDK: 'https://ttdk.com.vn'
}

const REACT_APP_RUNTIME_MODE = process.env.REACT_APP_RUNTIME_MODE
const DEFAULT_URLS = REACT_APP_RUNTIME_MODE === 'developer' ? DEVELOP_URL : PRODUCTION_URL

export const REACT_APP_URL_WEB_DATLICH = process.env.REACT_APP_URL_WEB_DATLICH || DEFAULT_URLS.REACT_APP_URL_WEB_DATLICH
export const REACT_APP_URL_WEB_TTDK = process.env.REACT_APP_URL_WEB_TTDK || DEFAULT_URLS.REACT_APP_URL_WEB_TTDK

export const getRuntimeHost = () => {
  if (typeof window === 'undefined') {
    return HOST
  }

  const runtimeHost = window.sessionStorage.getItem('BHXM_RUNTIME_API_URL')
  if (!runtimeHost) {
    return HOST
  }

  const pathname = window.location?.pathname || ''
  if (!pathname.includes(PATH.INSURENCE_OBLIGATORY)) {
    window.sessionStorage.removeItem('BHXM_RUNTIME_API_URL')
    return HOST
  }

  return runtimeHost
}
